import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './HeaderCards.module.scss'

import { useNavigate } from 'react-router-dom'
const HeaderCards = ({ data, isUser }) => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const dataType = [
    {
      title: t('statistic.reports_card'),
      value: data?.percent?.raport,
      color: 'rgba(201, 29, 29, 0.6)',
    },
    {
      title: t('statistic.statements_card'),
      value: data?.percent?.statement,
      color: 'rgba(240, 57, 145, 0.44)',
    },
    {
      title: t('statistic.tasks'),
      value: data?.percent?.task,
      color: 'rgba(6, 6, 6, 0.33)',
    },
    {
      title: t('statistic.subtasks'),
      value: data?.percent?.subtask,
      color: 'rgba(240, 145, 57, 0.44)',
    },
  ]

  return (
    <>
      <div
        className={styles.card}
        style={{
          background: 'var(--color-accent)',
        }}
      >
        <div className={styles.flex_col}>
          <div>
            <h4>{t('statistic.stages')}</h4>
            <h3>{data?.stage}</h3>
          </div>
          <p>{t('statistic.realized')}</p>
        </div>
      </div>
      <div
        className={styles.card}
        style={{
          background: 'var(--color-success)',
        }}
      >
        <div className={styles.flex_col}>
          <div>
            <h4>{t('statistic.tasks_subtasks')}</h4>
            <h3>{data?.task_subtask}</h3>
          </div>
          <p>{t('statistic.completed')}</p>
        </div>
      </div>
      <div
        className={styles.card}
        style={{
          background: 'var(--color-warning)',
        }}
      >
        <div className={styles.flex_col}>
          <div>
            <h4>{t('statistic.appeals_label')}</h4>
            <h3>{data?.conversions}</h3>
          </div>
          <p>{t('statistic.completed')}</p>
        </div>
      </div>
      <div className={styles.double_cards}>
        <div
          className={styles.mini_card}
          style={{
            background: 'var(--color-accent)',
          }}
        >
          <div className={styles.flex_col}>
            <h4>{t('statistic.efficiency')}</h4>
            <h3>{data?.kpi}%</h3>{' '}
          </div>
        </div>
        <div
          className={styles.mini_card}
          style={{
            background: 'var(--color-accent-hover)',
          }}
        >
          <div className={styles.flex_col}>
            {' '}
            <h4>{t('statistic.satisfaction')}</h4>
            {data?.quiz === 0 && isUser ? (
              <h4
                style={{ cursor: 'pointer', color: 'white' }}
                onClick={() => navigate('/answer-quiz')}
              >
                {t('statistic.take_survey')}
              </h4>
            ) : (
              <h4 style={{ color: 'white' }}>
                {data?.quiz ? `${data?.quiz}%` : t('statistic.survey_not_taken')}{' '}
              </h4>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default HeaderCards
